import React from 'react';

import './tab-layout.scss';

export const TabLayout = ({ children, activeIndex = 0, onChange, renderAllTabs = false }) => {
  const tabs = React.Children.toArray(children);

  return (
    <div className="tab-layout">
      <div className="tab-layout__tab-header">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-layout__tab ${index === activeIndex ? 'tab-layout__tab--active' : ''}`}
            onClick={() => onChange && onChange(index)}
            type="button"
          >
            <span>{tab.props.title}</span>
            <span />
          </button>
        ))}
      </div>

      <div className="tab-layout__tab-content">
        {renderAllTabs
          ? tabs.map((tab, index) => (
              <div
                key={index}
                className="tab-layout__tab-panel"
                style={{ display: index === activeIndex ? 'flex' : 'none' }}
              >
                {tab}
              </div>
            ))
          : tabs[activeIndex]}
      </div>
    </div>
  );
};

export const TabItem = ({ children }) => {
  return <div>{children}</div>;
};
